import Menu from "./Menu";
import { FactCheck, Factory, Healing, People } from "@mui/icons-material";
import MenuItem from "./MenuItem";
import { useRole } from "../auth/role";
//import { useRole } from "../mock";

export default function SidebarMenu(props = {}) {
  const { hasAnyRole, hasRole, ROLES } = useRole();
  window.scrollTo(0, 0);

  return (
    // Build the app menu using common tis-react
    <Menu>
      {hasAnyRole() && (
        <MenuItem
          href="/manufacturer/profile/list"
          title="Manufacturer Profiles"
          icon={<Factory />}
        />
      )}
      {/* {hasRole([ ROLES.BOTTLER ]) && <MenuItem href="/manufacturer/profile/" title="Manufacturer Profile" icon={<Factory/>}/>} */}
      {hasRole([ROLES.ADMIN, ROLES.MFI_ADMIN, ROLES.QSE_MGR]) && (
        <MenuItem
          href="/users/list/"
          title="User Management"
          icon={<People />}
        />
      )}
      {/* <MenuItem href="#" title="BU Assessments" icon={<FactCheck/>}> */}
      {/* <MenuItem href="/bu-assessments/self-assessments" title="Self Assessments" icon={<FactCheck/>}/>
        <MenuItem href="/bu-assessments/quality-and-food-safety-assessments" title="Quality &amp; FS Assessments" icon={<FactCheck/>}/>
        <MenuItem href="/bu-assessments/environmental-and-safety-assessments" title="Env. &amp; Safety Assessments" icon={<FactCheck/>}/> */}
      {/* </MenuItem> */}
    </Menu>
  );
}
